import { Popover, Row, Typography } from 'antd';

import type { ExamId, UserExamPublic } from '/imports/domain';
import { DataMatrix } from '/imports/ui/components/DataMatrix';
import { Icon } from '/imports/ui/foundation/Icons';
import { formatPattern, hexPattern } from '/imports/utils/format';

/**
 * Session keys are hexadecimal strings. We encode them as a string of numbers
 * here for display in the datamatrix barcode.
 */
function encodeSessionKey(username: string) {
  return parseInt(username, 16).toString(10);
}

export interface ExamUserDataMatrixProps {
  // This field is used to enforce the presence of an examId, but the value is not used internally
  examId: ExamId;
  user: UserExamPublic;
  scale?: number;
}

export const ExamUserDataMatrix = ({ user, scale = 64 }: ExamUserDataMatrixProps) => (
  <span onClick={(e) => e.stopPropagation()} aria-hidden="true" data-testid="dataMatrix">
    <Popover
      placement="bottomRight"
      trigger="click"
      styles={{ root: { width: 170 } }}
      content={
        <Row justify="center">
          <Typography.Text strong style={{ fontSize: 18 }}>
            <span data-testid="examUserId" data-hide-in-tests>
              {formatPattern(user.username, hexPattern).formatted}
            </span>
          </Typography.Text>
        </Row>
      }
    >
      {user.examineeId ? (
        <div style={{ display: 'flex', alignItems: 'center', height: scale }}>
          <Icon name="check" />
        </div>
      ) : (
        <div style={{ width: scale }}>
          <DataMatrix message={encodeSessionKey(user.username)} scale={scale} />
        </div>
      )}
    </Popover>
  </span>
);
